<script lang="ts">
	import { t } from '$lib/i18n';
	import Breadcrumb from './Breadcrumb.svelte';
	import '../app.css';
	import { env } from '$env/dynamic/public';
	let searching = false;
	let isMenuVisible = false;

	function toggleMenu() {
		isMenuVisible = !isMenuVisible;
	}
</script>

<svelte:head>
	<style>
		@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@200;300;400;500;600;700;800&display=swap');
		body {
			font-family: 'Manrope', sans-serif;
		}
	</style>

	<meta property="og:image" content="{env.PUBLIC_SITE_URL}/martechtracker-logo-large.png" />
	<meta property="og:url" content={env.PUBLIC_SITE_URL} />
</svelte:head>

<div
	class="grid"
	style="min-height: 100%;
		 grid-template-rows: auto 1fr auto;"
>
	<header class="bg-gray-dark">
		<div
			class="{isMenuVisible
				? 'h-44'
				: ''} max-w-[85rem] px-[2rem] py-[1rem] mx-auto md:flex items-center"
		>
			<div class="w-1/4">
				<a href="/"
					><img alt="logo" src="/MarTech_logo-white.svg" class="h-[70px] hover:cursor-pointer" />
				</a>
			</div>

			<div class="hidden md:block md:w-3/4 text-right text-white mt-[0.2rem]">
				<div class="hover:cursor-pointer ml-[1rem] md:whitespace-nowrap">
					{#if !searching}
						<button
							on:click={() => {
								searching = !searching;
							}}
						>
							<svg
								class="inline-block w-[2rem] h-[2rem] hover:border-b-2"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke-width="1.5"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
								/>
							</svg>
						</button>
					{/if}

					{#if searching}
						<form method="GET" action="/search">
							<button
								on:click={() => {
									searching = !searching;
								}}
							>
								<svg
									class="inline-block w-[2rem] h-[2rem] hover:border-b-2"
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									stroke-width="1.5"
									stroke="currentColor"
									><path
										stroke-linecap="round"
										stroke-linejoin="round"
										d="M6 18L18 6M6 6l12 12"
									/></svg
								>
							</button>
							<input
								name="s"
								class="lg:w-[30rem] border border-[#b3b7bb] max-w-full lg:mr-[1rem] px-[2rem] py-[1rem] rounded-xl text-[#b3b7bb]"
								type="text"
								placeholder={$t('common.search-placeholder', {
									default: 'Search whitepapers, topics, case studies etc'
								})}
							/>
							<button class="bg-light-green px-[2rem] py-[1rem] rounded-xl text-white"
								>{$t('common.search', { default: 'Search ' })}</button
							>
						</form>
					{:else}
						<span class="text-[1.1rem] font-light">
							<div class="md:inline ml-[2rem] whitespace-nowrap hover:border-b-2">
								<a href="/about-us">{$t('common.menu.about-us', { default: 'About Us' })}</a>
							</div>
							<div class="md:inline ml-[2rem] whitespace-nowrap hover:border-b-2">
								<a href="/#how-it-works"
									>{$t('common.menu.how-it-works', { default: 'How it works' })}</a
								>
							</div>
							<div class="md:inline ml-[2rem] whitespace-nowrap hover:border-b-2">
								<a href="/contact-us">{$t('common.footer.contact-us', { default: 'Contact Us' })}</a
								>
							</div>
						</span>
					{/if}
				</div>
			</div>

			<div
				class="md:hidden md:w-3/4 text-right text-white mt-[0.2rem] absolute top-8 right-8 flex flex-col"
			>
				{#if isMenuVisible}
					<button on:click={searching ? () => (searching = false) : toggleMenu}>
						<svg
							class="h-8 absolute -right-[2px] -top-[11px]"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
						>
							<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
						</svg>
					</button>
				{:else}
					<button on:click={toggleMenu}>
						<svg
							class="absolute right-0 h-8"
							xmlns="http://www.w3.org/2000/svg"
							fill="white"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="white"
						>
							<path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16m-7 6h7" />
						</svg>
					</button>
				{/if}
				{#if isMenuVisible}
					<div class="mt-6 text-right text-white md:w-3/4">
						<span class="text-[1.1rem] font-light">
							<div class="hover:cursor-pointer ml-[1rem] md:whitespace-nowrap">
								{#if !searching}
									<button
										on:click={() => {
											searching = !searching;
										}}
										class="ml-8 md:inline whitespace-nowrap hover:border-b-2"
									>
										Search
										<svg
											class="inline-block w-[1.5rem] h-[1.5rem]"
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
											/>
										</svg>
									</button>
								{/if}

								{#if searching}
									<form method="GET" action="/search">
										<input
											name="s"
											class="mt-10 w-[23rem] border border-[#b3b7bb] max-w-full lg:mr-[1rem] px-[2rem] py-[1rem] rounded-xl text-[#b3b7bb]"
											type="text"
											placeholder={$t('common.search-placeholder', {
												default: 'Search whitepapers, topics, case studies etc'
											})}
										/>
									</form>
								{:else}
									<div class="ml-8 md:inline whitespace-nowrap hover:border-b-2">
										<a href="/about-us">About Us</a>
									</div>
									<div class="ml-8 md:inline whitespace-nowrap hover:border-b-2">
										<a href="/#how-it-works">How it works</a>
									</div>
									<div class="ml-8 md:inline whitespace-nowrap hover:border-b-2">
										<a href="/work-with-us">Work With Us</a>
									</div>
								{/if}
							</div>
						</span>
					</div>
				{/if}
			</div>
		</div>
	</header>

	<Breadcrumb crumbs={[]} />

	<slot />

	<footer class="bg-gray-dark">
		<div class="max-w-[85rem] p-[2.5rem] text-[.9rem] font-[200] mx-auto md:flex items-center">
			<div class="flex-1">
				<ul class="flex-1 p-0 m-0 text-white list-none">
					<li class="whitespace-nowrap">
						<a href="/about-us" class="hover:border-b-2"
							>{$t('common.footer.about-us', { default: `About Us` })}</a
						>
					</li>
					<li class="whitespace-nowrap">
						<a href="/contact-us" class="hover:border-b-2"
							>{$t('common.footer.contact-us', { default: `Contact Us` })}</a
						>
					</li>
				</ul>
			</div>
			<div class="flex-1">
				<ul class="flex-1 p-0 m-0 text-white list-none md:text-right">
					<li class="whitespace-nowrap">
						<a class="hover:border-b-2" target="_blank" href="https://preferences.berne.media/"
							>{$t('common.footer.update-preferences', { default: `Update your Preferences` })}</a
						>
					</li>
					<li class="whitespace-nowrap">
						<a
							class="hover:border-b-2"
							target="_blank"
							href="https://preferences.berne.media/privacy-notice"
							>{$t('common.footer.privacy-policy', { default: `Privacy Notice` })}</a
						>
					</li>
					<li class="">
						{$t('common.footer.copyright', { default: `© 2024 Berne UK LTD All Rights Reserved` })}
					</li>
				</ul>
			</div>
		</div>
	</footer>
</div>
